@if (isSuperAdmin) {
<div class="col-12 white-background common-border-radius" style="background-color: #fff;">
    <div class="grid">
        <div class="col-fixed">
            <form [formGroup]="formGroup" class="card flex justify-center">
                <p-select formControlName="selectedConfig" [options]="configCode" optionLabel="name" optionValue="code"
                   (onChange)="onSelectConfigCode($event)" placeholder="Select a Config" class="w-full md:w-56" />
            </form>
        </div>
        <div class="col form-field">
            <div [formGroup]="searchTenantConfigForm" class="form-field">
                <div class="form-control">
                    <input type="text" formControlName="searchConfigData" pInputText class="w-full"
                        (keyup)="searchDriver()" placeholder="Search" />
                </div>
            </div>
        </div>
        <div class="col flex align-items-end justify-content-end  mb-2 mr-3">
            <div class="page-buttons">
                <button appAccessProvider pButton type="button" icon="fa fa-plus" label="Add" (click)="showDialog()">
                </button>
            </div>
        </div>
    </div>
    <div class="card">
    <p-table [value]="filteredConfigData"  currentPageReportTemplate=" Total: {totalRecords}"[showCurrentPageReport]="true" [tableStyle]="{ 'min-width': 'auto' }" [paginator]="true" [rows]="50"
            [rowsPerPageOptions]="[50, 100, 150]">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="configKey" style="width: 40%" translate> {{labelKey}} <p-sortIcon
                            field="configKey"></p-sortIcon> </th>
                    <th style="width: 40%" translate> {{labelValue}}</th>
                    <th style="width: 20%" translate> {{labelAction}} </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-configData let-rowIndex="rowIndex">
                <tr>
                    <td> {{ configData.configKey || "NA" }} </td>
                    <td> {{ configData.configValue || "NA" }} </td>
                    <td class="flex column-gap-1">
                        <button class="negative-button" pButton label="Edit"
                            (click)="showDialog(configData, true)"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>



<p-dialog modal="true" position="center" styleClass="c-w-700" [responsive]="true" ng-style="overflow: auto"
    [(visible)]="visible" [contentStyle]="{'overflow':'auto'}" modal="true">
    <ng-template pTemplate="header">
        <label translate>  {{ isEdit ? ('Edit ' + codeString + ' Config') : ('Add ' + codeString + ' Config') }} </label>    </ng-template>
    <form [formGroup]='tenantConfigForm'>
        <div class="form-field col-12 md:col-12 lg:col-12">
            <div class="form-label">
                <label for="" translate>Key</label>
                <label class="asterisk">*</label>
            </div>
            <div class="form-control">
                <input type="text" pInputText formControlName="configKey"
                    (blur)="tenantConfigForm.controls.configKey.markAsTouched()" />
            </div>
            @if (tenantConfigForm.controls.configKey.invalid && (tenantConfigForm.controls.configKey.touched ||
            tenantConfigForm.controls.configKey.dirty) && tenantConfigForm.controls.configKey.errors?.required) {
            <small class="p-error">Key is required.</small>
            }
            @if (tenantConfigForm.controls.configKey.invalid && (tenantConfigForm.controls.configKey.touched ||
            tenantConfigForm.controls.configKey.dirty) && tenantConfigForm.controls.configKey.errors?.pattern) {
            <small class="p-error">Key must be lowercase underscore format (e.g. active_driver_count_limit).</small>
            }

        </div>
        <div class="form-field col-12 md:col-12 lg:col-12">
            <div class="form-label">
                <label for="" translate>Value</label>
                <label class="asterisk">*</label>
            </div>
            <div class="form-control">
                <input type="text" pInputText formControlName="configValue" />
            </div>
            @if (tenantConfigForm.controls.configValue.invalid && (tenantConfigForm.controls.configValue.touched ||
            tenantConfigForm.controls.configValue.dirty) && tenantConfigForm.controls.configValue.errors?.required) {
            <small class="p-error">Value is required.</small>
            }

        </div>
        <div class="form-buttons col-12">
            <button pButton type="button" [label]="isEdit ? 'Update' : 'Add'" icon="fa fa-check"
                [disabled]="tenantConfigForm.invalid || submitting" (click)="saveTenantConfig(code)"></button>
            <button class="negative-button" pButton type="button" icon="fa fa-close" (click)="visible = false"
                [label]="'Cancel'"></button>
        </div>
    </form>
</p-dialog>
}@else {
<div class="col-12 h-10rem">
    <div class="col-12 h-10rem flex justify-content-center align-items-center text-xl">
        Logged user Doesn't have access!!!
    </div>
</div>
}